export default __webpack_public_path__ + "static/media/parent-banner-new.7fb93f41.png";